// GOAL DOMAIN cell tags - single source of truth for every page that shows a
// goal's domain: GoalsPage, ClientHistory and the Goal Review page.
//
// `goalDomain` holds the list of domains and `goalSkills` the skills parallel
// to it. A goal with no skill of its own shows the domain alone - never
// "Play and Cognition - Play and Cognition".
const buildDomainTags = (row) => {
  const domains = Array.isArray(row?.goalDomain)
    ? row.goalDomain
    : String(row?.goalDomain || "")
        .split(",")
        .map((d) => d.trim())
        .filter(Boolean);

  const skills = Array.isArray(row?.goalSkills) ? row.goalSkills : [];

  const tags = [];
  domains.forEach((raw, i) => {
    const domain = String(raw || "").trim();
    if (!domain) return;

    let skill = String(skills[i] ?? "").trim();
    if (!skill || skill.toLowerCase() === "null") skill = "";
    // A domain repeated as its own skill carries no extra information.
    if (skill && skill.toLowerCase() === domain.toLowerCase()) skill = "";

    const tag = skill ? `${domain} - ${skill}` : domain;
    if (!tags.some((t) => t.toLowerCase() === tag.toLowerCase())) {
      tags.push(tag);
    }
  });

  return tags;
};

// Accepts a goal exactly as the API returns it (goal_domain / goal_skill) and
// returns the same tag list, so the review page does not have to reshape it.
const buildDomainTagsFromGoal = (goal) =>
  buildDomainTags({ goalDomain: goal?.goal_domain, goalSkills: goal?.goal_skill });

export { buildDomainTags, buildDomainTagsFromGoal };
export default buildDomainTags;
